// import React, { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
// import ProductCard from "../components/ProductCard";
// import { useAppContext } from "../context/AppContext";

// const Products = () => {
//   const [searchParams] = useSearchParams();
//   const { products } = useAppContext();

//   const [filters, setFilters] = useState({
//     categories: [],
//     maxPrice: 500,
//     colors: [],
//     brands: [],
//     sortBy: "featured",
//   });

//   const [filteredProducts, setFilteredProducts] = useState([]);

//   useEffect(() => {
//     const categoryParam = searchParams.get("category");
//     if (categoryParam) {
//       setFilters((prev) => ({
//         ...prev,
//         categories: [categoryParam],
//       }));
//     } else {
//       // If no category param, show all categories
//       setFilters((prev) => ({
//         ...prev,
//         categories: ["curtains", "sofa-covers", "pillows", "bedding"],
//         colors: ["red", "blue", "beige", "green", "gray"],
//         brands: ["luxe", "cozy", "elite"],
//       }));
//     }
//   }, [searchParams]);

//   useEffect(() => {
//     console.log("All Products:", products);
//     console.log("Active Filters:", filters);

//     const filtered = products.filter((product) => {
//       const matches =
//         (filters.categories.length === 0 ||
//           filters.categories.includes(product.category)) &&
//         product.price <= filters.maxPrice &&
//         (filters.colors.length === 0 ||
//           filters.colors.includes(product.color)) &&
//         (filters.brands.length === 0 || filters.brands.includes(product.brand));

//       if (!matches) console.log("Filtered out:", product);
//       return matches;
//     });

//     const sorted = sortProducts(filtered, filters.sortBy);
//     setFilteredProducts(sorted);
//   }, [filters, products]);

//   const sortProducts = (products, sortBy) => {
//     switch (sortBy) {
//       case "price-low":
//         return [...products].sort((a, b) => a.price - b.price);
//       case "price-high":
//         return [...products].sort((a, b) => b.price - a.price);
//       case "newest":
//         return [...products].sort(
//           (a, b) => (b.isNew || false) - (a.isNew || false)
//         );
//       case "popular":
//         return [...products].sort((a, b) => b.rating - a.rating);
//       default: // featured
//         return [...products].sort(
//           (a, b) => (b.isFeatured || false) - (a.isFeatured || false)
//         );
//     }
//   };

//   const updateFilter = (filterName, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterName]: value,
//     }));
//   };

//   const resetFilters = (section) => {
//     if (section === "categories") updateFilter("categories", []);
//     if (section === "colors") updateFilter("colors", []);
//     if (section === "brands") updateFilter("brands", []);
//   };

//   const categories = ["curtains", "sofa-covers", "pillows", "bedding"];
//   const colors = ["red", "blue", "beige", "green", "gray"];
//   const brands = ["luxe", "cozy", "elite"];

//   return (
//     <div className="container product-page" style={{marginTop: "50px"}}>
//       <aside className="filters">
//         <div className="filter-section">
//           <h3>
//             Categories{" "}
//             <button
//               className="reset-btn"
//               onClick={() => resetFilters("categories")}
//             >
//               Reset
//             </button>
//           </h3>
//           <div className="filter-options">
//             {categories.map((category) => (
//               <div className="filter-option" key={category}>
//                 <input
//                   type="checkbox"
//                   id={`cat-${category}`}
//                   checked={filters.categories.includes(category)}
//                   onChange={(e) => {
//                     const newCategories = e.target.checked
//                       ? [...filters.categories, category]
//                       : filters.categories.filter((c) => c !== category);
//                     updateFilter("categories", newCategories);
//                   }}
//                 />
//                 <label htmlFor={`cat-${category}`}>
//                   {category
//                     .replace("-", " ")
//                     .replace(/\b\w/g, (c) => c.toUpperCase())}
//                 </label>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="filter-section">
//           <h3>
//             Colors{" "}
//             <button
//               className="reset-btn"
//               onClick={() => resetFilters("colors")}
//             >
//               Reset
//             </button>
//           </h3>
//           <div className="filter-options">
//             {colors.map((color) => (
//               <div className="filter-option" key={color}>
//                 <input
//                   type="checkbox"
//                   id={`color-${color}`}
//                   checked={filters.colors.includes(color)}
//                   onChange={(e) => {
//                     const newColors = e.target.checked
//                       ? [...filters.colors, color]
//                       : filters.colors.filter((c) => c !== color);
//                     updateFilter("colors", newColors);
//                   }}
//                 />
//                 <label htmlFor={`color-${color}`}>
//                   {color.charAt(0).toUpperCase() + color.slice(1)}
//                 </label>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="filter-section">
//           <h3>
//             Brands{" "}
//             <button
//               className="reset-btn"
//               onClick={() => resetFilters("brands")}
//             >
//               Reset
//             </button>
//           </h3>
//           <div className="filter-options">
//             {brands.map((brand) => (
//               <div className="filter-option" key={brand}>
//                 <input
//                   type="checkbox"
//                   id={`brand-${brand}`}
//                   checked={filters.brands.includes(brand)}
//                   onChange={(e) => {
//                     const newBrands = e.target.checked
//                       ? [...filters.brands, brand]
//                       : filters.brands.filter((b) => b !== brand);
//                     updateFilter("brands", newBrands);
//                   }}
//                 />
//                 <label htmlFor={`brand-${brand}`}>
//                   {brand.charAt(0).toUpperCase() + brand.slice(1)}
//                 </label>
//               </div>
//             ))}
//           </div>
//         </div>
//       </aside>

//       <main className="products-area">
//         <div className="sorting-bar">
//           <div className="results-count">
//             Showing <span>{filteredProducts.length}</span> products
//           </div>
//           <div className="sorting-options">
//             <span>Sort by:</span>
//             <select
//               value={filters.sortBy}
//               onChange={(e) => updateFilter("sortBy", e.target.value)}
//             >
//               <option value="featured">Featured</option>
//               <option value="price-low">Price: Low to High</option>
//               <option value="price-high">Price: High to Low</option>
//               <option value="newest">Newest Arrivals</option>
//               <option value="popular">Most Popular</option>
//             </select>
//           </div>
//         </div>

//         <div className="products-grid">
//           {filteredProducts.length > 0 ? (
//             filteredProducts.map((product) => (
//               <ProductCard key={product.id} product={product} />
//             ))
//           ) : (
//             <p className="no-results">
//               No products match your filters. Try adjusting your criteria.
//             </p>
//           )}
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Products;


import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { useAppContext } from "../context/AppContext";

const Products = () => {
  const [searchParams] = useSearchParams();
  const { products } = useAppContext();

  const [filters, setFilters] = useState({
    categories: [],
    maxPrice: 500,
    colors: [],
    brands: [],
    sortBy: "featured",
  });

  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    const categoryParam = searchParams.get("category");
    if (categoryParam) {
      setFilters((prev) => ({
        ...prev,
        categories: [categoryParam],
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        categories: ["curtains", "sofa-covers", "pillows", "bedding"],
        colors: ["red", "blue", "beige", "green", "gray"],
        brands: ["luxe", "cozy", "elite"],
      }));
    }
  }, [searchParams]);

  useEffect(() => {
    const filtered = products.filter((product) => {
      return (
        (filters.categories.length === 0 ||
          filters.categories.includes(product.category)) &&
        product.price <= filters.maxPrice &&
        (filters.colors.length === 0 ||
          filters.colors.includes(product.color)) &&
        (filters.brands.length === 0 ||
          filters.brands.includes(product.brand))
      );
    });

    const sorted = sortProducts(filtered, filters.sortBy);
    setFilteredProducts(sorted);
  }, [filters, products]);

  const sortProducts = (products, sortBy) => {
    switch (sortBy) {
      case "price-low":
        return [...products].sort((a, b) => a.price - b.price);
      case "price-high":
        return [...products].sort((a, b) => b.price - a.price);
      case "newest":
        return [...products].sort(
          (a, b) => (b.isNew || false) - (a.isNew || false)
        );
      case "popular":
        return [...products].sort((a, b) => b.rating - a.rating);
      default: // featured
        return [...products].sort(
          (a, b) => (b.isFeatured || false) - (a.isFeatured || false)
        );
    }
  };

  const updateFilter = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const resetFilters = (section) => {
    if (section === "categories") updateFilter("categories", []);
    if (section === "colors") updateFilter("colors", []);
    if (section === "brands") updateFilter("brands", []);
    if (section === "maxPrice") updateFilter("maxPrice", 500);
  };

  const categories = ["curtains", "sofa-covers", "pillows", "bedding"];
  const colors = ["red", "blue", "beige", "green", "gray"];
  const brands = ["luxe", "cozy", "elite"];

  return (
    <div className="container product-page" style={{ marginTop: "50px" }}>
      <aside className="filters">
        <div className="filter-section">
          <h3>
            Categories{" "}
            <button
              className="reset-btn"
              onClick={() => resetFilters("categories")}
            >
              Reset
            </button>
          </h3>
          <div className="filter-options">
            {categories.map((category) => (
              <div className="filter-option" key={category}>
                <input
                  type="checkbox"
                  id={`cat-${category}`}
                  checked={filters.categories.includes(category)}
                  onChange={(e) => {
                    const newCategories = e.target.checked
                      ? [...filters.categories, category]
                      : filters.categories.filter((c) => c !== category);
                    updateFilter("categories", newCategories);
                  }}
                />
                <label htmlFor={`cat-${category}`}>
                  {category
                    .replace("-", " ")
                    .replace(/\b\w/g, (c) => c.toUpperCase())}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <h3>
            Colors{" "}
            <button
              className="reset-btn"
              onClick={() => resetFilters("colors")}
            >
              Reset
            </button>
          </h3>
          <div className="filter-options">
            {colors.map((color) => (
              <div className="filter-option" key={color}>
                <input
                  type="checkbox"
                  id={`color-${color}`}
                  checked={filters.colors.includes(color)}
                  onChange={(e) => {
                    const newColors = e.target.checked
                      ? [...filters.colors, color]
                      : filters.colors.filter((c) => c !== color);
                    updateFilter("colors", newColors);
                  }}
                />
                <label htmlFor={`color-${color}`}>
                  {color.charAt(0).toUpperCase() + color.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="filter-section">
          <h3>
            Brands{" "}
            <button
              className="reset-btn"
              onClick={() => resetFilters("brands")}
            >
              Reset
            </button>
          </h3>
          <div className="filter-options">
            {brands.map((brand) => (
              <div className="filter-option" key={brand}>
                <input
                  type="checkbox"
                  id={`brand-${brand}`}
                  checked={filters.brands.includes(brand)}
                  onChange={(e) => {
                    const newBrands = e.target.checked
                      ? [...filters.brands, brand]
                      : filters.brands.filter((b) => b !== brand);
                    updateFilter("brands", newBrands);
                  }}
                />
                <label htmlFor={`brand-${brand}`}>
                  {brand.charAt(0).toUpperCase() + brand.slice(1)}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Max Price Filter Section */}
        <div className="filter-section">
          <h3>
            Max Price: ${filters.maxPrice}
            <button
              className="reset-btn"
              onClick={() => resetFilters("maxPrice")}
              style={{ marginLeft: "10px" }}
            >
              Reset
            </button>
          </h3>
          <div className="filter-options">
            <input
              type="range"
              min="0"
              max="500"
              step="10"
              value={filters.maxPrice}
              onChange={(e) =>
                updateFilter("maxPrice", parseInt(e.target.value))
              }
            />
          </div>
        </div>
      </aside>

      <main className="products-area">
        <div className="sorting-bar">
          <div className="results-count">
            Showing <span>{filteredProducts.length}</span> products
          </div>
          <div className="sorting-options">
            <span>Sort by:</span>
            <select
              value={filters.sortBy}
              onChange={(e) => updateFilter("sortBy", e.target.value)}
            >
              <option value="featured">Featured</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="newest">Newest Arrivals</option>
              <option value="popular">Most Popular</option>
            </select>
          </div>
        </div>

        <div className="products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))
          ) : (
            <p className="no-results">
              No products match your filters. Try adjusting your criteria.
            </p>
          )}
        </div>
      </main>
    </div>
  );
};

export default Products;
